export const LOAD_PROFILE_REQUEST = 'LOAD_PROFILE_REQUEST';
export const LOAD_PROFILE_SUCCESS = 'LOAD_PROFILE_SUCCESS';
export const LOAD_PROFILE_FAILURE = 'LOAD_PROFILE_FAILURE';

export const UPDATE_PROFILE_REQUEST = 'UPDATE_PROFILE_REQUEST';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const UPDATE_PROFILE_FAILURE = 'UPDATE_PROFILE_FAILURE';

export const PROFILE_STATUS_GUEST = 1;
export const PROFILE_STATUS_FREE = 2;
export const PROFILE_STATUS_SCREENING = 3;
export const PROFILE_STATUS_SUBSCRIPTION = 4;
export const PROFILE_STATUS_SELF_SERVICE = 5;
export const PROFILE_STATUS_SELF_SUPPORT = 6;
export const PROFILE_STATUS_MONITORING = 7;
export const PROFILE_STATUS_ADVICES = 8;
export const PROFILE_STATUS_PROACTIVE = 9;
export const PROFILE_STATUS_VIP = 10;
export const PROFILE_STATUS_OLDFREE = 11;
